<template>
  <section
    class="component-b4c019ae"
    resmed-component-name="feature_video_3grid_cta"
    v-bind:style="{ background: acf.layout['background'] }"
  >
    <transition name="fade">
      <div class="component" v-if="inview">
        <div class="container px-xs-sm-2">
          <div class="row">
            <div class="col">
              <eyebrow-icon
                v-if="acf.eyebrowicon"
                v-bind:eyebrowicon="acf.eyebrowicon"
                v-bind:align="
                  acf.layout['alignment'] === 'center' ? 'center' : ''
                "
              ></eyebrow-icon>
              <h2 v-bind:class="[`-options-align-${acf.layout.alignment}`]">
                {{ acf.headline }}
              </h2>
            </div>
          </div>
          <div class="row">
            <!-- md lg xl -->
            <div
              class="col-lg-9"
              v-if="$root.mode !== 'xs' && $root.mode !== 'sm'"
            >
              <div class="stage">
                <div class="entry embed-responsive embed-responsive-16by9">
                  <!-- <iframe v-bind:src='`//players.brightcove.net/2750693505001/${player}/index.html?videoId=${active}`'allowfullscreen webkitallowfullscreen mozallowfullscreen allow="encrypted-media" style="position: absolute; top: 0px; right: 0px; bottom: 0px; left: 0px; width: 100%; height: 100%;"></iframe> -->

                  <video-js
                    v-bind:data-video-id="`${active}`"
                    v-bind:data-player="`${player}`"
                    v-bind:data-account="`${account}`"
                    data-embed="default"
                    id="stage"
                    class="video-js vjs-16-9 embed-responsive-item"
                    controls
                  >
                  </video-js>
                </div>
              </div>
            </div>
            <div class="col-lg-3">
              <div class="items mt-3 mt-lg-0">
                <!-- xs sm -->
                <div
                  class="stage"
                  v-bind:class="[`order-${order}`]"
                  v-if="$root.mode === 'xs' || $root.mode === 'sm'"
                >
                  <div class="entry embed-responsive embed-responsive-16by9">
                    <video-js
                      v-bind:data-video-id="`${active}`"
                      v-bind:data-player="`${player}`"
                      v-bind:data-account="`${account}`"
                      data-embed="default"
                      id="stage"
                      class="video-js vjs-16-9 embed-responsive-item"
                      controls
                    >
                    </video-js>
                  </div>
                </div>

                <div
                  class="item embed-responsive embed-responsive-16by9"
                  v-for="(item, index) in items"
                  v-bind:class="{
                    [`order-${index + 1}`]: true,
                    'is-active': active === item.id,
                  }"
                  v-on:click="swap(item, index)"
                >
                  <figure class="embed-responsive-item">
                    <figcaption>
                      <p class="now-playing">Now playing</p>
                    </figcaption>
                    <div
                      class="embed-responsive-item poster"
                      v-bind:style="{
                        'background-image': `url(${item.poster})`,
                      }"
                      :key="componentKey"
                    ></div>
                  </figure>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4" v-if="cta.href">
            <div class="col-md-12 text-center">
              <a
                v-bind:href="cta.href"
                v-bind:target="cta.target[0]"
                class="btn cta-pill filled-red icon right-arrow"
                >{{ cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import debounce from "lodash/debounce";
import inview from "../../mixins/inview";

export default {
  name: "component-b4c019ae", // feature_video_3grid_cta
  props: ["acf"],
  data() {
    return {
      stage: {},
      order: 0,
      account: "",
      active: "",
      player: "",
      items: [],
      cta: [],
      componentKey: 0,
    };
  },
  mixins: [inview],
  watch: {
    inview(val) {
      val && this.getscript();
    },
  },
  methods: {
    swap(item, index) {
      this.order = index + 1;
      this.active = item.id;
      this.player = item.player;

      this.stage.catalog.getVideo(this.active, (error, video) => {
        this.stage.catalog.load(video);
        this.stage.play(); // enable and disable autoplay
      });
    },
    loaded() {
      this.stage = videojs.getPlayer("stage");

      videojs.getPlayer("stage").ready(() => {
        this.stage.on("loadstart", () => {});
        this.stage.on("ended", () => {});
      });
    },
    getscript() {
      $.getScript(
        `https://players.brightcove.net/2750693505001/${this.player}_default/index.min.js`,
        (data, textStatus, jqxhr) => {
          this.loaded();
        }
      );
    },
    forceRerender() {
      this.componentKey += 1;
    },
    debounce: debounce(function (arr) {
      // from --> md lg xl to either xs sm
      if (
        (arr[1] === "md" || arr[1] === "lg" || arr[1] === "xl") &&
        (arr[0] === "xs" || arr[0] === "sm")
      ) {
        this.getscript();
      }

      // from --> xs sm to either md lg xl
      if (
        (arr[1] === "xs" || arr[1] === "sm") &&
        (arr[0] === "md" || arr[0] === "lg" || arr[0] === "xl")
      ) {
        this.getscript();
      }
    }, 200),
  },
  mounted() {
    // this.getscript();

    // switch stage node
    bus.$on("mode", (arr) => {
      this.debounce(arr);
    });
  },
  created() {
    this.account = this.acf.account;
    this.items = this.acf.items;
    this.cta = this.acf.cta;

    this.active = this.acf.items[0].id;
    this.player = this.acf.items[0].player;

    // get video images (poster-frames)
    for (let item of this.items) {
      item.poster = "";

      axios
        .get(
          `//${location.hostname}/wp-json/resmed/v1/brightcove-thumbnail/${item.id}`
        )
        .then((response) => {
          item.poster = response.data.poster.src;
          this.forceRerender();
        });
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-b4c019ae {
  padding: 5rem 0 6rem 0;
  background: linear-gradient(#1788c3, #004275);
}

h2 {
  position: relative;
  margin-bottom: 1.5rem;
  color: $cc-resmed-white;

  @extend %eyebrow-left;
  &:before {
    background-color: $cc-resmed-white;
  }

  &.-options-align-center {
    text-align: center;

    &:before {
      left: 50%;
      transform: translateX(-50%);
    }
  }
}

h3 {
  margin-bottom: 0.5rem;

  @media (min-width: 576px) {
    font-size: 1.125em;
  }

  @media (min-width: 1200px) {
    font-size: 1.5em;
  }
}

.stage {
  margin: 0 0 1rem 0;
  box-shadow: 0 1.25rem 3.75rem 0 rgba(0, 0, 0, 0.3);

  @media (min-width: 768px) {
    margin: 0;
  }
}

.items {
  display: flex;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    margin: 0 -0.5rem;
  }

  @media (min-width: 992px) {
    display: block;
    margin: 0;
  }

  .item {
    margin: 0 0 1rem 0;

    @media (min-width: 768px) {
      width: 33.33%;
      margin: 0 0.5rem;
    }

    @media (min-width: 992px) {
      width: 100%;
      margin: 0 0 0.65rem 0;

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  .item {
    background-color: $cc-resmed-black;
    box-shadow: 0 1.25rem 3.75rem 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;

    figure {
      &:before {
        content: "";
        position: absolute;
        width: 100%;
        padding-top: 56.25%;
        z-index: 2;
        background-image: url("#{$assets}/images/icon-play-button.svg");
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 4rem 4rem;
        opacity: 0.825;
        transition: opacity 0.5s ease;
      }

      &:hover {
        &:before {
          opacity: 1;
        }
      }

      > div {
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
      }

      figcaption {
        padding: 1.25rem 1.5rem;
        color: $cc-resmed-white;

        position: absolute;
        z-index: 1;
      }
    }

    .now-playing {
      display: none;
    }

    &.is-active {
      cursor: default;

      @media (max-width: 767px) {
        display: none;
      }

      .poster {
        opacity: 0.25;
      }

      figure {
        &:before {
          opacity: 0 !important;
        }

        .now-playing {
          @extend %body-small-bold;
          background: $cc-resmed-grey-70;
          opacity: 0.825;

          display: inline-block;
          padding: 0.675rem 2rem;
          border-radius: 1.5rem;

          white-space: nowrap;
        }
      }

      figcaption {
        padding: 0;

        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>